import {
  SET_FILTER_SEARCH,
  SET_SORT_BY_SEARCH,
  RESET_USER_DASHBOARD_FILTER,
  SET_USER_DASHBOARD_KEYWORD,
  SET_USER_DASHBOARD_SORT,
  SET_USER_DASHBOARD_CATEGORY,
  SET_USER_DASHBOARD_STATUS,
  RESET_USER_DASHBOARD_KEYWORD,
  SET_USER_DASHBOARD_PAGE,
} from '../constants';

const initialState = {
  isFilterOpen: true,
  isSortOpen: false,
  isMaintenanceMode: false,
  userDashboardKeyword: '',
  userDashboardSort: '',
  userDashboardCategory: '',
  userDashboardStatus: '',
  userDashboardPage: 1,
  isRequiredHardRefresh: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${SET_FILTER_SEARCH}`: {
      return { ...state, isFilterOpen: action.data };
    }
    case `${SET_SORT_BY_SEARCH}`: {
      return { ...state, isSortOpen: action.data };
    }
    case `${RESET_USER_DASHBOARD_FILTER}`: {
      return {
        ...state,
        userDashboardKeyword: '',
        userDashboardSort: '',
        userDashboardCategory: '',
        userDashboardStatus: '',
        userDashboardPage: 1,
      };
    }
    case `${SET_USER_DASHBOARD_KEYWORD}`: {
      return { ...state, userDashboardKeyword: action.data };
    }
    case `${SET_USER_DASHBOARD_SORT}`: {
      return { ...state, userDashboardSort: action.data };
    }
    case `${SET_USER_DASHBOARD_CATEGORY}`: {
      return { ...state, userDashboardCategory: action.data };
    }
    case `${SET_USER_DASHBOARD_STATUS}`: {
      return { ...state, userDashboardStatus: action.data };
    }
    case "ERROR_MAINTENANCE_MODE": {
      return { ...state, isMaintenanceMode: true };
    }
    case "ERROR_NEW_BUILD_HANDLER": {
      return { ...state, isRequiredHardRefresh: true };
    }
    case `${RESET_USER_DASHBOARD_KEYWORD}`: {
      return { ...state, userDashboardKeyword: '' };
    }
    case `${SET_USER_DASHBOARD_PAGE}`: {
      return { ...state, userDashboardPage: action.data };
    }
    default: return state;
  }
};

export default reducer;
